import { render, staticRenderFns } from "./TradeRequestItemForm.vue?vue&type=template&id=102b2650"
import script from "./TradeRequestItemForm.vue?vue&type=script&lang=js"
export * from "./TradeRequestItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports